import React from 'react';
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Box,
  Button,
} from '@material-ui/core';
import { Router } from 'config/i18n';

const useStyles = makeStyles((theme) => ({
  greyBG: {
    backgroundColor: theme.palette.grey.A000,
    [theme.breakpoints.only('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  mainContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(13),
    marginBottom: theme.spacing(13),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(12.5),
      marginBottom: theme.spacing(12.25),
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(6.5),
      marginBottom: theme.spacing(6.5),
    },
  },
  txtGrid: {
    [theme.breakpoints.up('lg')]: {
      order: 1,
      paddingLeft: `${theme.spacing(5.75)} !important`,
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    fontFamily: theme.typography.fontFamilySecondary,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(50),
      fontWeight: '500',
      marginBottom: theme.spacing(4.5),
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(2.75),
    },
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '500',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(22),
    },
  },
  getStartedBox: {
    marginTop: theme.spacing(4.5),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(6.25),
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(5),
    },
  },
  getStarted: {
    boxShadow: 'none',
  },
}));

const ReadyToEarn = ({ i18n }) => {
  const classes = useStyles();

  const handleBtnClick = () => {
    Router.push('/user/vehicles');
  };

  return (
    <>
      <Box className={classes.greyBG}>
        <Container maxWidth="xl" classes={{ root: classes.mainContainer }}>
          <Grid container justify="center" alignItems="center" spacing={2}>
            <Grid item xs={12} lg={6} classes={{ item: classes.txtGrid }}>
              <Typography variant="h2" classes={{ root: classes.title }}>
                {i18n('fe_commercial_host_banner_shared:ready_to_earn')}
              </Typography>
              <Typography variant="h3" classes={{ root: classes.subTitle }}>
                {i18n('fe_commercial_host_banner_shared:join_community')}
              </Typography>
              <Box className={classes.getStartedBox}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleBtnClick}
                  classes={{ root: classes.getStarted }}
                >
                  {i18n('fe_commercial_host_banner_shared:get_started')}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ReadyToEarn;
